(function () {
  var meta_pixel_id = '1426663504206353';
  var fbq_initialised = false;

  function marketingAllowed() {
    var privacy_api = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy_api) return false;
    return privacy_api.analyticsProcessingAllowed() && privacy_api.marketingAllowed();
  }

  function initMetaPixel() {
    if (fbq_initialised) return;
    fbq_initialised = true;

    if (typeof fbq === 'undefined') {
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
      document,'script','https://connect.facebook.net/en_US/fbevents.js');
    }

    fbq('init', meta_pixel_id);
  }

  window.addEventListener('klaviyoForms', function (event) {
    if (event.detail.type !== 'submit' && event.detail.type !== 'stepSubmit') return;

    // Multi-step forms fire stepSubmit per step — only count the step that
    // captured the email, and let single-step forms through on submit
    if (event.detail.type === 'stepSubmit' && !event.detail.metaData?.$email) return;

    if (!marketingAllowed()) return;

    initMetaPixel();
    fbq('trackSingle', meta_pixel_id, 'Lead');
  });
})();